import React, { useEffect, useState, useRef } from "react";
import { toast, ToastContainer } from "react-toastify";
import Select from "react-select";
import ApiCallServices from "../../../services/ApiCallServices";
import { END_POINTS } from "../../../services/endpoint/endPoint";
import button from "../../button.module.css";
import DemandListing from "./child/DemandListing";
import MultiselectCheckbox from "../../common/multiselect-checkbox/MultiselectCheckbox";

const DemandPartner = () => {
  const initialState = {
    name: "",
    email: "",
    currency: "USD",
    contact: "",
    address: "",
    logo: "",
    description: "",
  };
  const [partnerList, setPartnerList] = useState([]);
  const [showHideModal, setShowHideModal] = useState(false);
  const [showHideDealModal, setShowHideDealModal] = useState(false);
  const [createPartner, setCreatePartner] = useState(initialState);
  const [searchBy, setSearchBy] = useState();
  const [isEditMode, setIsEditMode] = useState();
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState();
  const [dealsList, setDealsList] = useState([]);
  const [selectedNewDeals, setSelectedNewDeals] = useState();

  const getAllPartners = () => {
    let data = {
      name: searchBy || "",
    };
    ApiCallServices.create(END_POINTS.demandPartnerTableList, data)
      .then((res) => {
        console.log(res, "resres");
        if (res.status == 200) {
          setPartnerList(res.data.data);
        }
      })
      .catch((error) => {
        // Handle errors here
        if (error.response) {
          toast.error(error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };

  const handleNewDealsChange = (value) => {
    setSelectedNewDeals(value);
  };

  const validateForm = () => {
    const errors = {};

    if (!createPartner?.name) errors.name = "Name is required";
    //if (!createPartner?.email) errors.email = "Email is required";
    //if (!createPartner?.currency ) errors.currency = "Currency is required";
    if (!createPartner?.logo && !isEditMode) errors.logo = "Logo is required";

    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const createNewPartner = (e) => {
    e.preventDefault();
    if (!validateForm()) {
      return;
    }

    const formData = new FormData();
    formData.append("id", createPartner.id);
    formData.append("logo", createPartner.logo ? createPartner.logo : "");
    formData.append("name", createPartner.name);
    //formData.append("email", createPartner.email);
    //formData.append("currency", createPartner.currency);
    formData.append(
      "contact",
      createPartner.contact ? createPartner.contact : ""
    );
    formData.append(
      "address",
      createPartner.address ? createPartner.address : ""
    );
    formData.append(
      "description",
      createPartner.description ? createPartner.description : ""
    );

    document?.body?.removeAttribute("style");

    if (isEditMode) {
      ApiCallServices.fileUpload(END_POINTS.updateDemandPartner, formData).then(
        (res) => {
          if (res.status == 200) {
            toast.success("updated partner", {
              position: "top-right",
            });
            setIsEditMode(false);
            setCreatePartner(initialState);
            setShowHideModal(false);
            getAllPartners();
          }
        }
      );
    } else {
      ApiCallServices.fileUpload(END_POINTS.createDemandPartner, formData)
        .then((res) => {
          console.log(res, ":create demand****");
          if (res.status == 200) {
            setIsEditMode(false);
            setCreatePartner(initialState);
            setShowHideModal(false);
            getAllPartners();
            // Clear the file input field
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
            toast.success("created new partner", {
              position: "top-right",
            });
          }
        })
        .catch((error) => {
          // Handle errors here
          if (error.response) {
            toast.error("err in creating", {
              position: "top-right",
            });
            console.log(error.response.data, "===>error in getting response");
          }
        });
    }
  };

  const getPartnerById = (id) => {
    ApiCallServices.create(END_POINTS.getDemandPartnerById, { id: id })
      .then((res) => {
        if (res.status === 200) {
          setShowHideModal(true);
          document.body.style = "overflow: hidden";
          setIsEditMode(true);
          setCreatePartner(res.data.data);
        }
      })
      .catch((errors) => {
        console.log(errors, "===***errors");
      });
  };

  const addDeals = (id) => {
    ApiCallServices.create(END_POINTS.getDemandPartnerById, { id: id })
      .then((res) => {
        if (res.status === 200) {
          setShowHideDealModal(true);
          document.body.style = "overflow: hidden";
          setIsEditMode(true);
          setCreatePartner(res.data.data);
        }
      })
      .catch((errors) => {
        console.log(errors, "===***errors");
      });
  };

  const getDealsList = () => {
    ApiCallServices.getlisting(END_POINTS.dealsList)
      .then((res) => {
        console.log(res);
        if (res.status == 200) {
          setDealsList(res.data.data);
        }
      })
      .catch((error) => {
        // Handle errors here
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(error.response, "===>error in getting response");
        }
      });
  };
  useEffect(() => {
    getDealsList();
  }, []);

  const mapNewDeals = (e) => {
    e.preventDefault();

    if (!selectedNewDeals || selectedNewDeals.length === 0) {
      toast.error("Please select at least one deal", {
        position: "top-right",
      });
      return;
    }

    const formData = {
      demand_partner_id: createPartner.id,
      deal_id: selectedNewDeals.map((deal) => deal.id),
    };

    ApiCallServices.create(END_POINTS.mapNewDeals, formData)
      .then((res) => {
        if (res.status === 200) {
          toast.success("Deals successfully mapped", {
            position: "top-right",
          });
          setShowHideDealModal(false);
          // getAllPartners();
          setSelectedNewDeals([]);
          closeDealModal();
          getAllPartners();
          getDealsList();
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error("Error mapping deals", {
            position: "top-right",
          });
          console.log(error.response.data, "===>error in mapping deals");
        }
      });
  };

  const customStyles = {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#fff"
        : state.isFocused
        ? "#6abfe94d"
        : undefined,
      color: state.isSelected ? "white" : "black",
      padding: 10,
      display: "flex",
      alignItems: "center",
    }),
  };

  const handleHideShowModal = () => {
    setShowHideModal(true);
    document.body.style = "overflow: hidden";
  };
  const handleHideShowDealModal = () => {
    setShowHideDealModal(true);
    document.body.style = "overflow: hidden";
  };

  useEffect(() => {
    getAllPartners();
  }, [searchBy]);

  const handleOnChangeInput = (e) => {
    setCreatePartner((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const uploadImage = (e) => {
    console.log(e.target.files[0], "*****9999");
    setCreatePartner((prevState) => ({
      ...prevState,
      logo: e.target.files[0],
    }));
  };

  const closeModal = () => {
    setCreatePartner(initialState);
    setShowHideModal(false);
    document?.body?.removeAttribute("style");
    setErrors({});
    setIsEditMode(false);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const closeDealModal = () => {
    setSelectedNewDeals([]);
    setCreatePartner(initialState);
    setShowHideDealModal(false);
    document?.body?.removeAttribute("style");
    setErrors({});
  };

  useEffect(() => {
    if (!showHideDealModal) {
      setSelectedNewDeals([]);
    }
  }, [showHideDealModal]);

  const searchFilter = (e) => {
    if (e.target.value.length > 1) {
      setSearchBy(e.target.value);
    } else {
      setSearchBy("");
    }
  };

  const updatePartnerStatus = (id, status) => {
    ApiCallServices.create(END_POINTS.demandPartnerStatus, {
      id: id,
      status: status,
    })
      .then((res) => {
        if (res.status === 200) {
          toast.success(res.data.message, {
            position: "top-right",
          });
          getAllPartners();
        }
      })
      .catch((error) => {
        if (error.response) {
          toast.error(error.response.data.error, {
            position: "top-right",
          });
          console.log(
            error.response,
            "===>error in getting response status****"
          );
        }
      });
  };
  const confirmUpdate = (id, status) => {
    if (window.confirm("Are you sure you want to Update this User")) {
      updatePartnerStatus(id, status);
    }
  };

  console.log(dealsList, "****dealsList");
  return (
    <>
      <ToastContainer />
      <div className="container-fluid">
      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage Demand Partners</h3>
          </div>
      </div>

        <div className="filter-wraper d-flex justify-content-between">
          <div className="d-flex align-items-center fields">
            <div className="form-group search-icon">
              <input
                type="text"
                className="form-control"
                placeholder="Search name & email"
                onChange={searchFilter}
              />
            </div>
          </div>
          <div className="form-group d-flex justify-content-end">
            <button
              type="button"
              className={`${button.btn} ${button.btnDarkBlue}`}
              onClick={handleHideShowModal}
            >
              Add New Demand Partner
            </button>
          </div>
        </div>
        <DemandListing
          partnerList={partnerList}
          updateStatus={confirmUpdate}
          getPartnerById={getPartnerById}
          addDeals={addDeals}
        />
      </div>
      {/* add Demand partner modal */}
      <div className={`modal form-modal ${showHideModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">
                {isEditMode
                  ? "Update Demand Partner"
                  : "Add New Demand Partner"}
              </h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={closeModal}
              ></i>
            </div>

            <div className="modal-body">
              <form onSubmit={createNewPartner}>
                <div className="form-wraper">
                  <div className="form-group">
                    <label>
                      Name <span className="astric">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Enter Demand Partner Name"
                      name="name"
                      className="form-control"
                      value={createPartner?.name}
                      onChange={handleOnChangeInput}
                    />
                    {errors?.name && (
                      <div className="input-error">{errors.name}</div>
                    )}
                  </div>
                  {/* <div className="form-group">
                              <label>Email <span className="astric">*</span></label>
                              <input type="text" placeholder="Email" name= "email" className="form-control" value={createPartner?.email} onChange={handleOnChangeInput}/>
                              {errors?.email && <div className="input-error">{errors.name}</div>}
                          </div>
                          <div className="form-group">
                              <label>Currency <span className="astric">*</span></label>
                              <select className='form-control' name= "currency" value={createPartner.currency} onChange={handleOnChangeInput}>
                                <option >Select Currency</option>
                                <option value="EUR"> EUR</option>
                                <option value="USD"> USD </option>
                              </select>
                              {errors?.currency && <div className="input-error">{errors.currency}</div>}
                              <input type="text" placeholder="Currency"  className="form-control" value={createPartner?.currency} onChange={handleOnChangeInput}/>
                              {errors?.currency && <div className="input-error">{errors.currency}</div>}
                          </div> */}
                  <div className="form-group">
                    <label>
                      Logo image{" "}
                      {!isEditMode && <span className="astric">*</span>}
                    </label>
                    <input
                      type="file"
                      name="logo"
                      className="form-control"
                      ref={fileInputRef}
                      onChange={uploadImage}
                    />
                    {errors?.logo && (
                      <div className="input-error">{errors.logo}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label>Contact No </label>
                    <input
                      type="number"
                      placeholder="Contact No"
                      name="contact"
                      className="form-control"
                      value={createPartner?.contact}
                      onChange={handleOnChangeInput}
                    />
                  </div>

                  

                  <div className="form-group">
                    <label>Address </label>
                    <textarea
                      className="form-control"
                      placeholder="Enter Address"
                      name="address"
                      value={createPartner?.address}
                      onChange={handleOnChangeInput}
                    ></textarea>
                  </div>
                  <div className="form-group">
                    <label>Comments </label>
                    <textarea
                      className="form-control"
                      name="description"
                      placeholder="Enter Comments"
                      value={createPartner?.description}
                      onChange={handleOnChangeInput}
                    ></textarea>
                  </div>
                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Create"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div className={`${showHideModal ? "overlay" : ""}`}></div>
      {/* add deals */}
      <div className={`modal form-modal ${showHideDealModal ? "show" : ""}`}>
        <div className="modal-dialog modal-md">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Add Deals</h4>
              <i
                className="fa-regular fa-circle-xmark close-icon"
                onClick={closeDealModal}
              ></i>
            </div>

            <div className="modal-body">
              <form onSubmit={mapNewDeals}>
                <div className="form-wraper">
                  <div className="form-group custome-select multicheck">
                    <label>Deal List</label>
                    <Select
                      placeholder="Select Deals"
                      isClearable="true"
                      isMulti={true}
                      hideSelectedOptions={false}
                      closeMenuOnSelect={false}
                      value={selectedNewDeals}
                      onChange={handleNewDealsChange}
                      options={dealsList}
                      getOptionLabel={(dealsList) => dealsList.deal_name}
                      getOptionValue={(dealsList) => dealsList.id}
                      components={{ Option: MultiselectCheckbox }}
                      styles={customStyles}
                    />
                  </div>

                  <div className="text-end">
                    <button
                      type="submit"
                      className={`${button.btn} ${button.btnBlue}`}
                    >
                      {isEditMode ? "Update" : "Create"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* add deals */}
    </>
  );
};

export default DemandPartner;
